import React from "react";
import { Children } from "react";
function Button({ children }) {
    return (
        <>
            <button className=' bg-blue-500 w-full text-white py-[7px] rounded-[7px]'>
                {children}
            </button>
        </>
    );
}

export default Button;
